import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import { Alert } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Localization from 'l18n/l18n';
import * as React from 'react';
import {Helmet} from 'react-helmet';
import Bg from '../../assets/images/bg.png';
import Logo from '../../assets/images/sihatec-logo.png';
import AuthUser from '../../models/auth';

const styles = {
  container: {
      alignItems: 'center',
      height: '100vh',
      backgroundImage: 'url(' + Bg +')',
      backgroundSize: 'cover',

  }
};

const Img = styled('img')({  
      marginleft: '-2000',
      maxWidth: 200,
      maxHeight: '100%',
      marginTop: 14,
});

const StyledTextField = styled(TextField)({
  border:'0 !important',
  borderRadius:0,
  background:'#eeeeee',
  width:'100%',
  '& .MuiOutlinedInput-root' : {
    '& fieldset': {            // - The <fieldset> inside the Input-root
      border:0 // - Set the Input border
    },
   
  }
});

export default function SignIn() {
  const [error, setError] = React.useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    setError(false);
    const data = new FormData(event.currentTarget);  
    const email = data.get('email').toString() ;
    const password = data.get('password') ;

    const regexForEmail = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

    if (!String(email).toLowerCase().match(regexForEmail)) {
      setError(['email',Localization.translate['invalid_email']]);
      return;
    } else if(String(password).length < 6) {
      setError(['password',Localization.translate['invalid_password']]);
      return;

    }else{

    AuthUser.singIn(email,password)
    .then((data)=>{
      window.location.reload();
    })
    .catch((error)=>{
 
      if (error === 'email_not_found') {
        setError(['email',Localization.translate['email_not_found']]);
      } else if (error === 'empty_email' || error === 'invalid_email') {
        setError(['email',Localization.translate['invalid_email']]);
      } else if(error==='password_not_match' || error === 'weak_password')
      setError(['password',Localization.translate['invalid_password']]);
      else{
        setError(['error',Localization.translate['error']]);
      }
     
    });
  }
};

const errorMessage = (error[0]==='error') ? <Alert severity='error' >{error[1]}</Alert> :'' ;

  return (
    <>
    <Helmet>
        <title>{`${Localization.translate['app_name']} | ${Localization.translate['sign_in']}`}</title>
    </Helmet>
    <Container  component="main" maxWidth="100%" style={styles.container}>
      <Img alt='logo' src={Logo} />
      <CssBaseline />
      <Box
          sx={{
            margin:'0 auto',
            marginTop: 6,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            maxWidth:'40rem',
          }}>
          <Avatar sx={{ m: -10, bgcolor: 'primary.main', width:120, height:120}}>
            <PersonOutlineIcon sx={{fontSize:'5rem'}} />
          </Avatar>
        <Card variant="outlined" sx={{ minWidth: 275, padding: 7,borderRadius:'2rem' }} >
          <Typography component="h1" variant="h5" sx={{textAlign:'center', my: 6,fontWeight:'bold' }}>
            {Localization.translate['welcome']}
          </Typography>
          <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
            <Grid container>
            <Grid item xs={ 12 } >
                <Typography sx={ { mt: 2, ml: 1, fontWeight: 'bold' } }>
                    {Localization.translate['email']}
                </Typography>

            <StyledTextField
              margin="normal"
              required
              fullWidth
              id="email"
              placeholder={Localization.translate['email']}
              name="email"
              autoComplete="email"
              error={error[0] === 'email'}
              helperText={error[0] === 'email' ? error[1] : ''}
              autoFocus
              />
              </Grid>
              <Grid item xs={ 12 } >
                <Typography sx={ { mt: 2, ml: 1, fontWeight: 'bold' } }>
                    {Localization.translate['password']}
                </Typography>

            <StyledTextField
              margin="normal"
              required
              fullWidth
              name="password"
              error={error[0] === 'password'}
              helperText={error[0] === 'password' ? error[1] : ''}
              placeholder={Localization.translate['password']}
              type="password"
              id="password"
              autoComplete="current-password"
              />
              </Grid>

            {/* <FormControlLabel
              control={<Checkbox value="remember" color="primary" />}
              label={Localization.translate["remember_me"]}
            /> */}

            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={ {  padding: '0.5rem 4rem',mt:4, boxShadow: 'none', borderRadius: 0, color: '#FFFFFF',} }
              >
              {Localization.translate['sign_in']}
            </Button>
              </Grid>
            <Grid item xs={12}>
              {errorMessage}
              </Grid>
            <Grid container>
              <Grid item xs sx={{textAlign:'center', mt: 3}}>
                <Link href={'forgot-password'} style={{textDecoration:'none'}} variant="body2">
                  {Localization.translate['forgot_password']}
                </Link>
              </Grid>
            </Grid>
            <span dir="ltr">version 1.0.0 build 1</span>
          </Box>
        </Card>
      </Box>
    </Container>
  </>
  );
}